// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2017, 2018 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

:root {
  --theia-welcomeView-horizontal-padding: 20px;
  --theia-welcomeView-elements-margin: 13px;
  --theia-welcomeView-button-maxWidth: 260px;
}

.theia-Tree {
  overflow: hidden;
  font-size: var(--theia-ui-font-size1);
  max-height: calc(100% - var(--theia-border-width));
  position: relative;
}

.theia-Tree:focus .theia-TreeContainer.empty::before,
.theia-Tree:focus .theia-TreeContainer.focused::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
  content: "";
  outline-width: 1px;
  outline-style: solid;
  outline-offset: -1px;
  opacity: 1 !important;
  outline-color: var(--theia-focusBorder);
}

.theia-Tree:focus,
.theia-TreeContainer .ReactVirtualized__List:focus {
  outline: 0;
  box-shadow: none;
  border: none;
}

.theia-TreeContainer .ReactVirtualized__Grid__innerScrollContainer {
  margin-bottom: calc(var(--theia-ui-padding) * 3);
}

.theia-TreeContainer {
  height: 100%;
}

.theia-TreeNode {
  line-height: var(--theia-content-line-height);
  display: flex;
}

.theia-TreeNode:hover {
  background: var(--theia-list-hoverBackground);
  color: var(--theia-list-hoverForeground);
  cursor: pointer;
}

.theia-TreeNodeContent {
  display: flex;
  align-items: center;
  width: calc(100% - var(--theia-scrollbar-rail-width));
}

.theia-ExpansionToggle {
  display: flex;
  justify-content: center;
  padding-left: calc(var(--theia-ui-padding) / 2);
  padding-right: calc(var(--theia-ui-padding) / 2);
  min-width: var(--theia-icon-size);
  min-height: var(--theia-icon-size);
}

.theia-ExpansionToggle.theia-mod-busy {
  animation: theia-spin 1.25s linear infinite;
}

.theia-ExpansionToggle:not(.theia-mod-busy):hover {
  cursor: pointer;
}

.theia-ExpansionToggle.theia-mod-collapsed:not(.theia-mod-busy) {
  transform: rotate(-90deg);
}

.theia-Tree:focus-within .theia-TreeNode.theia-mod-selected {
  background: var(--theia-list-activeSelectionBackground);
  color: var(--theia-list-activeSelectionForeground) !important;
  outline: var(--theia-focusBorder) solid 1px;
  outline-offset: -1px;
}

.theia-Tree:focus-within .theia-TreeNode.theia-mod-selected .theia-TreeNodeTail,
.theia-Tree:focus-within
  .theia-TreeNode.theia-mod-selected
  .theia-caption-suffix,
.theia-Tree:focus-within .theia-TreeNode.theia-mod-selected .theia-TreeNodeInfo,
.theia-Tree:focus-within
  .theia-TreeNode.theia-mod-selected
  .theia-TreeNodeSegment {
  color: var(--theia-list-activeSelectionForeground) !important;
}

.theia-Tree:focus .theia-TreeNode.theia-mod-focus,
.theia-Tree .ReactVirtualized__List:focus .theia-TreeNode.theia-mod-focus {
  outline-width: 1px;
  outline-style: solid;
  outline-offset: -1px;
  outline-color: var(--theia-focusBorder);
}

.theia-TreeNodeInfo {
  color: var(--theia-foreground);
  opacity: 0.7;
}

.theia-Tree .theia-TreeNode.theia-mod-selected {
  background: var(--theia-list-inactiveSelectionBackground);
  color: var(--theia-list-inactiveSelectionForeground);
}

.theia-TreeNode.theia-mod-not-selectable {
  color: var(--theia-descriptionForeground);
}

.theia-TreeNode.theia-mod-not-selectable:hover {
  background: none;
  cursor: default;
}

.theia-TreeNodeSegment {
  align-items: center;
  flex-grow: 0;
  user-select: none;
  white-space: nowrap;
}

.theia-TreeNodeSegment.flex {
  display: flex;
}

.theia-TreeNodeSegmentGrow {
  flex-grow: 1 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.theia-TreeNodeTail {
  min-width: 1rem;
  text-align: center;
  justify-content: center;
}

.open-editors-node-row .theia-TreeNode .theia-TreeNodeContent .noWrapInfo > * {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline;
}

.theia-TreeNodeSegment mark {
  background-color: var(--theia-list-filterMatchBackground);
  color: var(--theia-list-inactiveSelectionForeground);
}

.theia-tree-source-node-placeholder {
  text-align: center;
  font-style: italic;
  opacity: var(--theia-mod-disabled-opacity);
}

.theia-tree-node-indent {
  position: absolute;
  height: var(--theia-content-line-height);
  border-right: var(--theia-border-width) solid transparent;
  pointer-events: none;
}

.theia-tree-node-indent.always,
.theia-TreeContainer:hover .theia-tree-node-indent.hover {
  border-color: var(--theia-tree-inactiveIndentGuidesStroke);
}

.theia-tree-node-indent.active {
  border-color: var(--theia-tree-indentGuidesStroke);
}

.theia-TreeContainer .theia-WelcomeView {
  padding-top: var(--theia-ui-padding);
  padding-right: var(--theia-welcomeView-horizontal-padding);
  padding-left: var(--theia-welcomeView-horizontal-padding);
}

.theia-TreeContainer .theia-WelcomeView > * {
  margin: var(--theia-welcomeView-elements-margin) 0;
}

.theia-TreeContainer .theia-WelcomeView .theia-WelcomeViewButtonWrapper {
  display: flex;
  padding: 0 var(--theia-ui-padding);
}

.theia-TreeContainer .theia-WelcomeView .theia-WelcomeViewButton {
  width: 100%;
  max-width: var(--theia-welcomeView-button-maxWidth);
  margin: auto;
}

.theia-TreeContainer .theia-WelcomeView .theia-WelcomeViewCommandLink {
  cursor: pointer;
}

.theia-TreeContainer .theia-WelcomeView .theia-WelcomeViewCommandLink.disabled {
  pointer-events: none;
  cursor: default;
  opacity: var(--theia-mod-disabled-opacity);
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/browser/style/tree.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,4CAA4C;EAC5C,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;;EAEE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,6CAA6C;EAC7C,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,+CAA+C;EAC/C,gDAAgD;EAChD,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uDAAuD;EACvD,6DAA6D;EAC7D,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;;;;;;;;EAQE,6DAA6D;AAC/D;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,yDAAyD;EACzD,oDAAoD;AACtD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;EACE,yDAAyD;EACzD,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,yDAAyD;EACzD,oBAAoB;AACtB;;AAEA;;EAEE,0DAA0D;AAC5D;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,oCAAoC;EACpC,0DAA0D;EAC1D,yDAAyD;AAC3D;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,mDAAmD;EACnD,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,0CAA0C;AAC5C","sourcesContent":["/********************************************************************************\n * Copyright (C) 2017, 2018 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n:root {\n  --theia-welcomeView-horizontal-padding: 20px;\n  --theia-welcomeView-elements-margin: 13px;\n  --theia-welcomeView-button-maxWidth: 260px;\n}\n\n.theia-Tree {\n  overflow: hidden;\n  font-size: var(--theia-ui-font-size1);\n  max-height: calc(100% - var(--theia-border-width));\n  position: relative;\n}\n\n.theia-Tree:focus .theia-TreeContainer.empty::before,\n.theia-Tree:focus .theia-TreeContainer.focused::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n  content: \"\";\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: -1px;\n  opacity: 1 !important;\n  outline-color: var(--theia-focusBorder);\n}\n\n.theia-Tree:focus,\n.theia-TreeContainer .ReactVirtualized__List:focus {\n  outline: 0;\n  box-shadow: none;\n  border: none;\n}\n\n.theia-TreeContainer .ReactVirtualized__Grid__innerScrollContainer {\n  margin-bottom: calc(var(--theia-ui-padding) * 3);\n}\n\n.theia-TreeContainer {\n  height: 100%;\n}\n\n.theia-TreeNode {\n  line-height: var(--theia-content-line-height);\n  display: flex;\n}\n\n.theia-TreeNode:hover {\n  background: var(--theia-list-hoverBackground);\n  color: var(--theia-list-hoverForeground);\n  cursor: pointer;\n}\n\n.theia-TreeNodeContent {\n  display: flex;\n  align-items: center;\n  width: calc(100% - var(--theia-scrollbar-rail-width));\n}\n\n.theia-ExpansionToggle {\n  display: flex;\n  justify-content: center;\n  padding-left: calc(var(--theia-ui-padding) / 2);\n  padding-right: calc(var(--theia-ui-padding) / 2);\n  min-width: var(--theia-icon-size);\n  min-height: var(--theia-icon-size);\n}\n\n.theia-ExpansionToggle.theia-mod-busy {\n  animation: theia-spin 1.25s linear infinite;\n}\n\n.theia-ExpansionToggle:not(.theia-mod-busy):hover {\n  cursor: pointer;\n}\n\n.theia-ExpansionToggle.theia-mod-collapsed:not(.theia-mod-busy) {\n  transform: rotate(-90deg);\n}\n\n.theia-Tree:focus-within .theia-TreeNode.theia-mod-selected {\n  background: var(--theia-list-activeSelectionBackground);\n  color: var(--theia-list-activeSelectionForeground) !important;\n  outline: var(--theia-focusBorder) solid 1px;\n  outline-offset: -1px;\n}\n\n.theia-Tree:focus-within .theia-TreeNode.theia-mod-selected .theia-TreeNodeTail,\n.theia-Tree:focus-within\n  .theia-TreeNode.theia-mod-selected\n  .theia-caption-suffix,\n.theia-Tree:focus-within .theia-TreeNode.theia-mod-selected .theia-TreeNodeInfo,\n.theia-Tree:focus-within\n  .theia-TreeNode.theia-mod-selected\n  .theia-TreeNodeSegment {\n  color: var(--theia-list-activeSelectionForeground) !important;\n}\n\n.theia-Tree:focus .theia-TreeNode.theia-mod-focus,\n.theia-Tree .ReactVirtualized__List:focus .theia-TreeNode.theia-mod-focus {\n  outline-width: 1px;\n  outline-style: solid;\n  outline-offset: -1px;\n  outline-color: var(--theia-focusBorder);\n}\n\n.theia-TreeNodeInfo {\n  color: var(--theia-foreground);\n  opacity: 0.7;\n}\n\n.theia-Tree .theia-TreeNode.theia-mod-selected {\n  background: var(--theia-list-inactiveSelectionBackground);\n  color: var(--theia-list-inactiveSelectionForeground);\n}\n\n.theia-TreeNode.theia-mod-not-selectable {\n  color: var(--theia-descriptionForeground);\n}\n\n.theia-TreeNode.theia-mod-not-selectable:hover {\n  background: none;\n  cursor: default;\n}\n\n.theia-TreeNodeSegment {\n  align-items: center;\n  flex-grow: 0;\n  user-select: none;\n  white-space: nowrap;\n}\n\n.theia-TreeNodeSegment.flex {\n  display: flex;\n}\n\n.theia-TreeNodeSegmentGrow {\n  flex-grow: 1 !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.theia-TreeNodeTail {\n  min-width: 1rem;\n  text-align: center;\n  justify-content: center;\n}\n\n.open-editors-node-row .theia-TreeNode .theia-TreeNodeContent .noWrapInfo > * {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: inline;\n}\n\n.theia-TreeNodeSegment mark {\n  background-color: var(--theia-list-filterMatchBackground);\n  color: var(--theia-list-inactiveSelectionForeground);\n}\n\n.theia-tree-source-node-placeholder {\n  text-align: center;\n  font-style: italic;\n  opacity: var(--theia-mod-disabled-opacity);\n}\n\n.theia-tree-node-indent {\n  position: absolute;\n  height: var(--theia-content-line-height);\n  border-right: var(--theia-border-width) solid transparent;\n  pointer-events: none;\n}\n\n.theia-tree-node-indent.always,\n.theia-TreeContainer:hover .theia-tree-node-indent.hover {\n  border-color: var(--theia-tree-inactiveIndentGuidesStroke);\n}\n\n.theia-tree-node-indent.active {\n  border-color: var(--theia-tree-indentGuidesStroke);\n}\n\n.theia-TreeContainer .theia-WelcomeView {\n  padding-top: var(--theia-ui-padding);\n  padding-right: var(--theia-welcomeView-horizontal-padding);\n  padding-left: var(--theia-welcomeView-horizontal-padding);\n}\n\n.theia-TreeContainer .theia-WelcomeView > * {\n  margin: var(--theia-welcomeView-elements-margin) 0;\n}\n\n.theia-TreeContainer .theia-WelcomeView .theia-WelcomeViewButtonWrapper {\n  display: flex;\n  padding: 0 var(--theia-ui-padding);\n}\n\n.theia-TreeContainer .theia-WelcomeView .theia-WelcomeViewButton {\n  width: 100%;\n  max-width: var(--theia-welcomeView-button-maxWidth);\n  margin: auto;\n}\n\n.theia-TreeContainer .theia-WelcomeView .theia-WelcomeViewCommandLink {\n  cursor: pointer;\n}\n\n.theia-TreeContainer .theia-WelcomeView .theia-WelcomeViewCommandLink.disabled {\n  pointer-events: none;\n  cursor: default;\n  opacity: var(--theia-mod-disabled-opacity);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
